const styles = {
  root: {},

  homeContent: {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 500,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  title: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center'
  },

  subtitle: {
    fontFamily: "'Montserrat', sans-serif",
    color: 'rgba(0,0,0,0.5)'
  },

  paper: {
    padding: 30,
    margin: 5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },

  impactCircle: {
    width: 250,
    height: 250,
    borderRadius: 125,
    backgroundColor: '#b1b3b5',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 30
  },

  logoImage: {
    width: 80
  },

  mealCountText: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.2rem'
  },

  countingText: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.2rem'
  },

  messageContainer: {
    marginTop: 10
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/home/styles.js